<template>
    <div class="mt-3">
        <az-loading v-if="!item" />        

        <div class="container" v-else>

            <div class="bg-dark text-white alert lead mb-3">
                {{ item.unidade_operacao ? item.unidade_operacao.st_nome : unidade.search }}
            </div>

            <p class="alert alert-info">
                {{ item.nome_paciente }}
            </p>

            <p>Credenciais para o reembolso:</p>

            <div v-if="atualizado">

                <div class="card">
                    <div class="card-body text-center">
                        <i class="fa fa-check-circle-o text-success fa-7x mb-3" aria-hidden="true"></i>
                        <h2>Credenciais atualizadas com sucesso!</h2>
                    </div>
                </div>

            </div>

            <div v-else>

                <div>
                    <az-input
                        :edicao="!loading"
                        ref="login"
                        label="Login"
                        v-model="credenciais.login" />
                </div>
                <div>
                    <az-input
                        :edicao="!loading"
                        label="Confirmação Login"
                        v-model="credenciais.login_confirm" />
                </div>
                <hr>
                <div>
                    <az-input
                        :edicao="!loading"
                        label="Senha"
                        v-model="credenciais.senha" />
                </div>
                <div>
                    <az-input
                        :edicao="!loading"
                        label="Confirmação da Senha"
                        v-model="credenciais.senha_confirm" />
                </div>

                <div class="d-flex flex-column mt-3">
                    <button type="button" class="btn btn-primary" :disable="loading" @click="atualizar()">
                        <div class="spinner-border spinner-border-sm mr-2" role="status" v-if="loading">
                          <span class="sr-only">Loading...</span>
                        </div>
                        Enviar
                    </button>
                </div>

            </div>

            <pre v-if="false">{{ item }}</pre>

            <Toast :baseZIndex="99999" />
        </div>
    </div>
</template>

<script>
import AzInput from '../shared/forms/AzInput.vue';
import AzLoading from '../util/AzLoading.vue';

export default {
    data() { 
        return { 
            dados: null, 
            item: null, 
            credenciais: { 
                login: "",
                login_confirm: "",
                senha: "",
                senha_confirm: "", 
            },
            unidade: null,
            atualizado: false,
        }
    },

    components: { 
        AzInput, 
        AzLoading,
    },

    computed: { 
        loading: function () { 
            return this.$store.state.loading;
        },
    },

    props: ['tipo', 'id', 'token'],

    methods: { 
        load() { 
            this.axios
                .post("/reembolso/dados", { tipo: this.tipo, id: this.id, token: this.token })
                .then(res => {
                    if (res.response && res.response.status > 400) {
                        this.status = res.response.data;
                        this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: res.response.data,
                        life: 3000
                        });
                    } else {
                        this.item = res.data.item;
                        this.unidade = res.data.unidade;
                        
                        this.$nextTick(() => { 
                            this.$refs['login'].$refs.input.focus ();
                        });
                    }
                })
                .catch(err => {
                    alert(err);
                })
                .finally(() => {
                    this.$store.commit("loading", false);
                });
        },

        atualizar() { 
            this.$store.commit("loading", true);

            this.axios
                .post("/reembolso/salvar", { 
                    tipo: this.tipo, 
                    id: this.id, 
                    token: this.token,
                    ...this.credenciais, 
                })
                .then(res => {
                    if (res.response && res.response.status > 400) {
                        this.status = res.response.data;
                        //this.handleError(res);

                        /*
                        this.$toast.add({
                            severity: "error",
                            summary: "Atenção",
                            detail: res.response.data,
                            life: 3000
                        });
                        */
                    } else {
                        this.atualizado = true;
                    }
                })
                .catch(err => {
                    console.log(2, err.response);
                    alert(err);
                })
                .finally(() => {
                    this.$store.commit("loading", false);
                });
        }
    },

    mounted () {
        this.load(); 
    }
}
</script>